<template>
  <div class="application">
    <div class="header">
      <div class="title">应用场景</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in applicationList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileapplication1 from "../../../../assets/product/mobileapplication1.png";
import mobileapplication2 from "../../../../assets/product/mobileapplication2.png";
import mobileapplication3 from "../../../../assets/product/mobileapplication3.png";
import mobileapplication4 from "../../../../assets/product/mobileapplication4.png";
import mobileapplication5 from "../../../../assets/product/mobileapplication5.png";
import mobileapplication6 from "../../../../assets/product/mobileapplication6.png";
import mobileapplication7 from "../../../../assets/product/mobileapplication7.png";
import mobileapplication8 from "../../../../assets/product/mobileapplication8.png";

export default {
  setup() {
    return reactive({
      applicationList: [
        {
          id: 1,
          title: "住宅小区",
          logo: mobileapplication1,
        },
        {
          id: 2,
          title: "办公楼",
          logo: mobileapplication2,
        },
        {
          id: 3,
          title: "商场",
          logo: mobileapplication3,
        },
        {
          id: 4,
          title: "酒店",
          logo: mobileapplication4,
        },
        {
          id: 5,
          title: "产业园",
          logo: mobileapplication5,
        },
        {
          id: 6,
          title: "旅游景区",
          logo: mobileapplication6,
        },
        {
          id: 7,
          title: "工厂",
          logo: mobileapplication7,
        },
        {
          id: 8,
          title: "学校",
          logo: mobileapplication8,
        },
      ],
    });
  },
};
</script>

<style scoped>
.application {
  width: 100%;
  margin: 24px auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body .list {
  width: 92vw;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  justify-content: space-between;
}
.body .list .item {
  text-align: center;
  margin-bottom: 16px;
  overflow: hidden;
}
.body .list .item img {
  width: 164px;
}
.body .list .item div {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
}
</style>
